import { gql } from 'urql';

const GetDocument = gql`
  query GetDocument($id: ID!) {
    document(id: $id) {
      __typename
      id
      url
      format
      title
    }
  }
`;
export default GetDocument;
